/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ViastoriaIngestResultDto } from '../../models/viastoria-ingest-result-dto';
import { ViastoriaStreamIngestDto } from '../../models/viastoria-stream-ingest-dto';

export interface ViastoriaControllerIngestStream$Params {

/**
 * League this fixture belongs to, e.g. "viastoria"
 */
  Tenant: string;
      body: ViastoriaStreamIngestDto
}

export function viastoriaControllerIngestStream(http: HttpClient, rootUrl: string, params: ViastoriaControllerIngestStream$Params, context?: HttpContext): Observable<StrictHttpResponse<ViastoriaIngestResultDto>> {
  const rb = new RequestBuilder(rootUrl, viastoriaControllerIngestStream.PATH, 'post');
  if (params) {
    rb.header('Tenant', params.Tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ViastoriaIngestResultDto>;
    })
  );
}

viastoriaControllerIngestStream.PATH = '/integrations/viastoria/stream_ingest';
